module.exports = __webpack_public_path__ + "img/icon_map_4_on_110.b4cf9229.png";